export const empresa = [
  {
    label: "Id",
    name: "idempresa",
    type: "INTEGER",
    readonly: true,
  },
  {
    label: "Nombre",
    name: "descripcion",
    type: "STRING",
    showOnList: true,
    showAsLabel: true,
  },
  {
    label: "Nombre de fantasía",
    name: "nombre_fantasia",
    type: "STRING",
    allowNull: true,
  },
  {
    label: "Grupo",
    name: "idgrupo",
    type: "empresa",
    showOnList: true,
    allowNull: true,
    as: "grupo",
  },
  {
    label: "RUT",
    name: "rut",
    type: "STRING",
    showOnList: true,
  },
  {
    label: "Proveedor",
    name: "proveedor",
    type: "BOOLEAN",
    allowNull: false,
    showOnList: true,
  },
  {
    label: "Cliente",
    name: "cliente",
    type: "BOOLEAN",
    allowNull: false,
    showOnList: true,
  },
];
